import { createSlice } from '@reduxjs/toolkit';
import axios from 'axios';
import API from '../utils/api';
import encodeParams from '../utils/queryParam'

const initialState = {
  isLoading: false,
  data: {
    currentPage: 0,
    hasNext: false,
    hasPrevious: false,
    pageSize: 0,
    totalCount: 0,
    totalPages: 0,
    items: []
  },
};

const slice = createSlice({
  name: 'payment',
  initialState,
  reducers: {
    getList(state, action) {
      state.isLoading = false;
      state.data = action.payload;
    },
    setPending(state, action) {
      state.isLoading = true;
    },
  }
});

export const reducer = slice.reducer;

export const getList = (parameter,orgId,businessId) => async (dispatch) => {
  // dispatch(slice.actions.setPending());
  const url = `${API.URL_CONDITION}/${orgId}/action/GetConditionListWithPaging/${businessId}?${encodeParams(parameter)}`
  const response = await axios.get(url);
  dispatch(slice.actions.getList(response.data.data));
};

export const createCondition = async (orgId, data) => {
  try {
    const url = `${API.URL_CONDITION}/${orgId}/action/CreateCondition`;
    const req = await axios.post(url, data);
    const res = await req.data;
    return res;
  } catch (err) {
    console.log(JSON.stringify(err))
    return { isError: true };
  }
};

export const updateCondition = async (orgId, businessId, conditionId, data) => {
  try {
    const url = `${API.URL_CONDITION}/${orgId}/action/UpdateCondition/${businessId}/${conditionId}`;
    const req = await axios.post(url, data);
    const res = await req.data;
    return res;
  } catch (err) {
    console.log(JSON.stringify(err))
    return { isError: true };
  }
};

export const deleteCondition = async (orgId, businessId, conditionId, data) => {
  try {
    const url = `${API.URL_CONDITION}/${orgId}/action/DeleteCondition/${businessId}/${conditionId}`;
    const req = await axios.post(url, data);
    const res = await req.data;
    return res;
  } catch (err) {
    console.log(JSON.stringify(err))
    return { isError: true };
  }
};

export default slice;
